import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import EnhancedTable from '../../widgets/ResponsiveTable';
import LinkDialog from "../LinkDialog";
import Prompt from '../../widgets/Prompt';
import EmployerSearch from '../employer/EmployerSearch';
import EnhancedToolbar from '../../widgets/Toolbar';
import ViewUtils from '../../ViewUtils';
import AlertItem from "../../widgets/AlertItem";
import withMenuPermission from "../../widgets/withMenuPermission";

const headCells = [
    { id: 'OrganisationSDLNumber', numeric: false, disablePadding: true, label: 'SDL Number' },
    { id: "OrganisationTradeName", numeric: false, disablePadding: true, label: "Trade Name" },
    { id: "OrganisationLegalName", numeric: false, disablePadding: true, label: "Legal Name" },
]

const utils = new ViewUtils();
const toolbarRef = React.createRef();

class ModeratorEmployerSearch extends Component {

    constructor(props) {
        super(props)
        this.state = {
            model: {
                ModeratorID: this.props.location.state.ModeratorID
            },
            searchParameters: [
                { Name: "ModeratorID", Value: this.props.location.state.ModeratorID }
            ],
            linkDialogOpen: false,
            selectedEmployer: null,
            propmtOpen: false,
            promptTitle: "Unlink Employer From Moderator",
            promptContent: "Are you sure you want to unlink this Employer from the Moderator?",
            message: "",
            messageStyle: "",
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'link', label: '', tooltip: 'Link Employer/s to the Moderator', icon: 'LinkIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'unlink', label: '', tooltip: 'Un-link the selected Employer from the Moderator', disabled: utils.isNull(this.state.selectedEmployer), icon: 'LinkOffIcon', visible: this.props.menuPermissionItem.Delete }
                    ]
                }
            ]
        };

    }

    handleToolbarButtonClick = (buttonId) => {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/moderator',
                state: { selection: this.props.location.state.ModeratorID }
            });
        }
        else if ("link" === buttonId) {
            this.setState({ linkDialogOpen: true, message: "" })
        }
        else if ("unlink" === buttonId) {
            this.setState({ promptOpen: true })
        }
    }

    successCallback = (response) => {
        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({ selectedEmployer: null });
            //Force a refresh
            this.setState({
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase(),
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters))
            })
        }
        else if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({
                message: response.Message,
                messageStyle: response.MessageType.toLowerCase()
            })
        }
    }

    unsuccessfulUnlinkCallback = (response) => {
        if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({ removeMessage: response.Message, removeMessageStyle: response.MessageType.toLowerCase() })
        }
    }

    unlinkModeratorEmployer(url) {
        this.setState({ promptOpen: false }, () => {
            toolbarRef.current.setButtonDisabled("unlink", true);
        })

        let fullUrl = `${url}?id=${this.state.selectedEmployer}&moderatorId=${this.props.location.state.ModeratorID}`
        utils.invokeUrlDelete(fullUrl, this.successCallback, this.unsuccessfulUnlinkCallback);
    }

    postLinkHandler(isCancel, linked) {
        if (linked === true) {
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                linkDialogOpen: false, selectedEmployer: null
            });
        }
        else if (isCancel === true) {
            this.setState({
                linkDialogOpen: false
            })
        }
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({
                selectedEmployer: selection[0].Id,
                message: "",
                messageStyle: ""
            });
        }
        else {
            this.setState({
                selectedEmployer: null,
                message: "",
                messageStyle: ""
            });
        }
        toolbarRef.current.setButtonDisabled("unlink", selection === null || selection.length === 0);
    }

    closePrompt = () => {
        this.setState({ propmtOpen: false })
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="breadcrumbs">
                    {"Moderator > Employers" + (this.props.location.state !== null ? " > " + this.props.location.state.ModeratorName + " - " + this.props.location.state.ModeratorIDNo : "> Add")}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <div className="searchResults">
                    <EnhancedToolbar
                        ref={toolbarRef}
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        config={this.toolbarConfig} />
                    <EnhancedTable
                        headCells={headCells}
                        dataUrl={`api/sims/moderatorEmployer/GetModeratorEmployer`}
                        height="50vh"
                        onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                        searchParameters={this.state.searchParameters} paged={true} />
                </div>

                <LinkDialog open={this.state.linkDialogOpen} type={this.state.selectedLinkType}
                    title={this.props.location.state.ModeratorName}
                    closeHandler={(isCancelled, linked) => this.postLinkHandler(isCancelled, linked)}
                    dialogTitle={`Link Employer to Moderator: ${this.props.location.state.ModeratorName}`}
                    linkName={"Employers"} postUrl={"api/sims/moderatorEmployer/LinkModeratorEmployer"} usePost={true}
                    selectionId={this.props.location.state.ModeratorID}
                >
                    <EmployerSearch
                        dataUrl={"api/sims/moderatorEmployer/GetSearchLinkableEmployers"}
                        multiSelect={true} showTitle={false}
                        programmeId={this.props.location.state.ModeratorID} programmeType="Q"
                        mode="lookup"
                    />
                </LinkDialog>

                <Prompt open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => this.unlinkModeratorEmployer(`api/sims/moderatorEmployer/RemoveModeratorEmployer`)}
                    closePrompt={this.closePrompt}
                />
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(ModeratorEmployerSearch));